import { ShippingMethods } from '@/enums/shippingMethod';

export function getShippingTypeMessageId(method: ShippingMethods): string {
    switch (method) {
        case ShippingMethods.BidderShipping:
            return 'checkout.paymentProcessedNotification.message.bidderShipping';
        case ShippingMethods.HouseShipping:
            return 'checkout.paymentProcessedNotification.message.houseShipping';
        case ShippingMethods.LiveShipping:
            return 'checkout.paymentProcessedNotification.message.liveShipping';
        case ShippingMethods.Pickup:
        default:
            return 'checkout.paymentProcessedNotification.message.pickup';
    }
}
